import { sortBy } from 'lodash';

import routingGroupsResource from 'src/actions/routingGroups/routingGroupsResource';
import { useResourceValues } from 'src/presentation/hooks/useResource';

export default function useRoutingGroups() {
  const { loadingState, values } = useResourceValues(routingGroupsResource);
  return {
    loadingState,
    values: sortBy(
      values
        .filter(({ disabled }) => !disabled)
        .map(({ id, name }) => {
          return { label: name, value: id };
        }),
      ['label']
    ),
  };
}
